export interface Skill {
  area: "front" | "back" | "mobile" | "infra" | "others";
  name: string;
  color: string;
}
export const mySkill: Array<Skill> = [
  {
    area: "front",
    name: "react",
    color: "57c4e1",
  },
  {
    area: "front",
    name: "Redux",
    color: "593D88",
  },
  {
    area: "front",
    name: "react router",
    color: "CA4245",
  },
  {
    area: "front",
    name: "typescript",
    color: "3178C6",
  },
  {
    area: "front",
    name: "javascript",
    color: "c5b218",
  },
  {
    area: "front",
    name: "Android",
    color: "3DDC84",
  },
  {
    area: "front",
    name: "HTML5",
    color: "E34F26",
  },
  {
    area: "front",
    name: "CSS3",
    color: "1572B6",
  },
  {
    area: "front",
    name: "Sass",
    color: "CC6699",
  },
  {
    area: "front",
    name: "styled components",
    color: "DB7093",
  },
  {
    area: "back",
    name: "Spring",
    color: "6DB33F",
  },
  {
    area: "back",
    name: "OpenJDK",
    color: "ED8B00",
  },
  {
    area: "back",
    name: "Amazon AWS",
    color: "232F3E",
  },
  {
    area: "back",
    name: "MariaDB",
    color: "003545",
  },
  {
    area: "back",
    name: "MySQL",
    color: "4479A1",
  },
  {
    area: "others",
    name: "git",
    color: "F05032",
  },
  {
    area: "others",
    name: "Slack",
    color: "4A154B",
  },
  {
    area: "others",
    name: "Figma",
    color: "F24E1E",
  },
  {
    area: "others",
    name: "microsoft teams",
    color: "6264A7",
  },
];
